import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowsLeftRight, X } from "@phosphor-icons/react";
import api from "@/lib/api";

export const AlternativesPanel = ({ item, onSwap, onClose }) => {
  const [alts, setAlts] = useState(null);
  const [swapping, setSwapping] = useState(null);

  useEffect(() => {
    let alive = true;
    api.post(`/shopping-list/${item.item_id}/alternatives`)
      .then(({ data }) => alive && setAlts(data.alternatives || []))
      .catch((e) => { if (alive) { toast.error(e?.response?.data?.detail || "Couldn't get alternatives"); onClose(); } });
    return () => { alive = false; };
  }, [item.item_id]); // eslint-disable-line react-hooks/exhaustive-deps

  const pick = async (alt) => {
    setSwapping(alt.name);
    await onSwap(item, alt.name);
    setSwapping(null);
  };

  return (
    <div className="mt-2 rounded-lg border border-rf-orange/30 bg-rf-amber/10 p-3" data-testid={`shop-alts-${item.item_id}`}>
      <div className="flex items-center justify-between mb-2">
        <p className="text-[11px] uppercase tracking-widest font-black text-rf-ink-soft">Out of stock? Try instead</p>
        <button onClick={onClose} aria-label="Close alternatives" data-testid="shop-alts-close" className="text-rf-ink-soft hover:text-rf-ink"><X size={14} /></button>
      </div>
      {item.usual_swap && (
        <button
          onClick={() => pick({ name: item.usual_swap })}
          disabled={!!swapping}
          data-testid="shop-alt-usual"
          className="mb-2 w-full text-left rounded-lg bg-rf-orange/10 border-2 border-rf-orange px-3 py-2 hover:bg-rf-orange/20 transition-colors disabled:opacity-50"
        >
          <span className="block text-[10px] uppercase tracking-widest font-black text-rf-orange">Your usual swap</span>
          <span className="flex items-center gap-1.5 text-sm font-bold text-rf-ink">
            <ArrowsLeftRight size={12} weight="bold" className="text-rf-orange" />
            {swapping === item.usual_swap ? "Swapping…" : item.usual_swap}
          </span>
        </button>
      )}
      {alts === null ? (
        <p className="text-sm text-rf-ink-soft animate-pulse" data-testid="shop-alts-loading">Finding alternatives…</p>
      ) : (
        <ul className="flex flex-wrap gap-2">
          {alts.filter((a) => a.name.toLowerCase() !== (item.usual_swap || "").toLowerCase()).map((a, i) => (
            <li key={a.name}>
              <button
                onClick={() => pick(a)}
                disabled={!!swapping}
                title={a.note}
                data-testid={`shop-alt-${i}`}
                className="text-left rounded-lg bg-white border border-rf-ink/10 px-3 py-2 hover:border-rf-orange hover:-translate-y-0.5 transition-[transform,border-color] duration-150 disabled:opacity-50"
              >
                <span className="flex items-center gap-1.5 text-sm font-bold text-rf-ink">
                  <ArrowsLeftRight size={12} weight="bold" className="text-rf-orange" />
                  {swapping === a.name ? "Swapping…" : a.name}
                </span>
                {a.note && <span className="block text-xs text-rf-ink-soft mt-0.5 max-w-[240px]">{a.note}</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
